import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getAttdToday,
  getAttdYesterday,
  getAttdTwoDay,
} from "../../api/attendance";
import CustomTable from "../common/CustomTable";
import { AttendanceColumns } from "../../utils/table/attendanceCols";
import React from "react";
import MessageContainer from "../common/MessageContainer";
import AttendanceDateFilter from "./AttendanceDateFilter";
import AttendanceSearchBar from "./AttendanceSearchBar";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  attendanceDateState,
  attendanceEmpModalIdState,
  modalTitle,
} from "../../utils/atoms/atoms";
import { useEffect } from "react";
import CustomModal from "../CustomModal";
import AttendanceYearsModalBody from "./AttendanceYearsModalBody";
import AttendanceMonthModalBody from "./AttendanceMonthModalBody";

const Attendance = () => {
  const attendanceDate = useRecoilValue(attendanceDateState);
  const setYearsModalTitle = useSetRecoilState(modalTitle);
  const {
    isLoading,
    data: attendance,
    isError,
    isSuccess,
  } = useQuery({
    queryKey: ["attendance_daily"],
    queryFn:
      attendanceDate === "today"
        ? getAttdToday
        : attendanceDate === "yesterday"
        ? getAttdYesterday
        : getAttdTwoDay,
  });

  const attendanceEmpModalId = useRecoilValue(attendanceEmpModalIdState);

  const queryClient = useQueryClient();
  const attendanceDailyMutation = useMutation({
    mutationFn: async (dateFilter: string) => {
      if (dateFilter === "yesterday") {
        return getAttdYesterday();
      } else if (dateFilter === "today") {
        return getAttdToday();
      } else {
        return getAttdTwoDay();
      }
    },
    onSuccess(data) {
      queryClient.setQueryData(["attendance_daily"], data);
    },
  });

  const attdModalTitle = useRecoilValue(modalTitle);

  useEffect(() => {
    attendanceDailyMutation.mutate(attendanceDate);
  }, [attendanceDate]);

  return (
    <React.Fragment>
      <div className="attendance-header mt-3">
        <AttendanceSearchBar />
        <div className="d-flex gap-2">
          <AttendanceDateFilter attdDate="today" />
          <AttendanceDateFilter attdDate="yesterday" />
          <AttendanceDateFilter attdDate="twoday" />
          <div
            className="styled-btn--std me-2 mobile-d-none"
            data-bs-toggle="modal"
            data-bs-target="#attendanceYearModal"
            onClick={() => {
              setYearsModalTitle("Years");
            }}
          >
            Year
          </div>
        </div>
      </div>

      {isLoading ? (
        <MessageContainer message={"Loading"} />
      ) : isSuccess && !isError ? (
        <CustomTable
          data={attendance?.attendance}
          columns={AttendanceColumns}
          isFilter={true}
          isPaginate={false}
        />
      ) : (
        <MessageContainer message={"Something Went Wrong"} isError />
      )}

      <CustomModal
        modalTitle={attdModalTitle}
        modalId="attendanceYearModal"
        modalBody={<AttendanceYearsModalBody />}
      />

      <CustomModal
        modalTitle={attdModalTitle}
        modalId="attendanceCurrentModal"
        modalBody={<AttendanceMonthModalBody empCode={attendanceEmpModalId} />}
      />
    </React.Fragment>
  );
};

export default Attendance;
